// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  GRAPHQL_URL: "https://tgsd3.all.co.tz/kiungo/",
  AUTH_SERVER_URL: "https://tgsd3.all.co.tz/tokeni-uaa/",
  FILE_SERVER_URL: "https://tgsd3.all.co.tz:9092/tgsd_file_media",
  // GRAPHQL_URL: "https://demo.services.gov.go.tz/kiungo/",
  // AUTH_SERVER_URL: "https://demo.services.gov.go.tz/tokeni-uaa/",
  // FILE_SERVER_URL: "https://demo.services.gov.go.tz:9081/tgsd_file_media",
  CLIENT_ID: "680c290a5480a7a58e27",
  CLIENT_SECRET: "50039db47fe4862f57cefee80881b7fb00d2a7ce",
  SESSION_TIMEOUT: 1800000
};

